import { ExternalValidationResultAlert } from "../../applications/documaker/domain/document";
import { RequestedObject } from "./RequestedObject";

export class ExternalValidationResults {
  constructor(
    public alerts: ExternalValidationResultAlert[],
    public objects: RequestedObject[],
  ) {}
}
